import React from "react";
import "./resources.css";
import pic1 from "../media/pic1.jpeg";
import pic2 from "../media/pic2.jpeg";
import pic3 from "../media/pic3.png";
import { ButtonGroup } from "@chakra-ui/button";

function Resources() {
  return (
    <div id="resource-page">
      <h1>
        {" "}
        Find Non-Profit Organizations fighting against Period Poverty to achieve
        gender equity{" "}
      </h1>
      <p id="intropara">
        According to research, there are 2 main reasons for period poverty. The
        lack of access to period products, such as pads, as well as the lack of
        access to menstrual hygiene education and clean sanitation facilities.
        Below are some of the NGOs that are working to end period poverty across
        the world.{" "}
      </p>
      <div id="card-collection">
        <div id="row1">
          <div id="card">
            <img src={pic1} />
            <div id="container">
              <h5>
                <b> Plan International </b>
              </h5>
              <p> Building Clean, Period Friendly Sanitation Facilities </p>
            </div>
          </div>
          <div id="card">
            <img src={pic2} />
            <div id="container">
              <h5>
                <b> Period Organization </b>
              </h5>
              <p> Advocating for Change, tampon taxes </p>
            </div>
          </div>
          <div id="card">
            <img src={pic3} />
            <div id="container">
              <h5>
                <b> For Girls </b>
              </h5>
              <p> Raising Awareness to end period poverty </p>
            </div>
          </div>
        </div>
        <div id="row2">
          <div id="card">
            <img src={pic1} />
            <div id="container">
              <h5>
                <b> Plan International </b>
              </h5>
              <p> Building Clean, Period Friendly Sanitation Facilities </p>
            </div>
          </div>
          <div id="card">
            <img src={pic2} />
            <div id="container">
              <h5>
                <b> Period Organization </b>
              </h5>
              <p> Advocating for Change, tampon taxes </p>
            </div>
          </div>
          <div id="card">
            <img src={pic3} />
            <div id="container">
              <h5>
                <b> For Girls </b>
              </h5>
              <p> Raising Awareness to end period poverty </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resources;
